import React from 'react';
import { X, Plus } from 'lucide-react';

const CompanyCreateModal = ({ isOpen, values, submitting, onClose, onSubmit, onChange }) => {
  if (!isOpen) return null;

  const handleChange = (field) => (event) => {
    onChange(field, event.target.value);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 px-4 pointer-events-auto">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6 relative">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Add New Company</h3>
            <p className="text-sm text-gray-500">Provide optional details to keep records consistent.</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
            aria-label="Close"
          >
            <X size={18} />
          </button>
      </div>
        <div className="mt-5 space-y-4">
          <div>
            <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Company Name *</label>
            <input
              type="text"
              value={values.name}
              onChange={handleChange('name')}
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              placeholder="Acme Inc."
              autoFocus
            />
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Website</label>
              <input
                type="text"
                value={values.website}
                onChange={handleChange('website')}
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="https://www.acme.com"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Domain</label>
              <input
                type="text"
                value={values.domain}
                onChange={handleChange('domain')}
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="acme.com"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Contact Email</label>
              <input
                type="email"
                value={values.email}
                onChange={handleChange('email')}
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="info@acme.com"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Phone</label>
              <input
                type="text"
                value={values.phone}
                onChange={handleChange('phone')}
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="+1 (555) 123-4567"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">City / Location</label>
              <input
                type="text"
                value={values.location}
                onChange={handleChange('location')}
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="San Francisco, CA"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Country</label>
              <input
                type="text"
                value={values.country}
                onChange={handleChange('country')}
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="United States"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">State / Province</label>
              <input
                type="text"
                value={values.state}
                onChange={handleChange('state')}
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="CA"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Postal / Zip Code</label>
              <input
                type="text"
                value={values.zip_code}
                onChange={handleChange('zip_code')}
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="94105"
              />
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Street Address</label>
            <input
              type="text"
              value={values.address}
              onChange={handleChange('address')}
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              placeholder="123 Main St Suite 100"
            />
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800"
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSubmit}
            className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-50"
            disabled={submitting}
          >
            <Plus size={14} />
            {submitting ? 'Creating...' : 'Create Company'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyCreateModal;
